import FrownDefault from '../../assets/icons/smiley-default-sad.svg';
import FrownInactive from '../../assets/icons/smiley-inactive-sad.svg';
import FrownSelected from '../../assets/icons/smiley-selected-sad.svg';

interface Props {
  state?: 'default' | 'inactive' | 'selected';
  className?: string;
}

export const Frown = ({ state = 'default', className }: Props) => {
  return (
    <img
      src={
        state === 'default' ? FrownDefault : state === 'inactive' ? FrownInactive : FrownSelected
      }
      alt="Smile"
      className={`${className || 'h-8 w-8'}`}
    />
  );
};
